import RSVP6 from './RSVP6'
export default RSVP6
